<template>
	<div class="index" id="foot">
		<footer class="index_footer">
			<div class="index_footer_link">
				<a >关于我们</a>
				<a >网站地址</a>
				<a >版权声明</a>
				<a >联系我们</a>
			</div>
			<ul class="index_footer_info">
				<li>
					<span>地址：北京市朝阳区华威西里甲19号</span>
					<span>邮编：100021</span>
				</li>
				<li>
					<span>电话：010-87789256</span>
					<span>传真：010-87789252</span>
					<span>邮箱：songyu@cfpa.cn</span>
				</li>
				<li>
					<span>版权所有：中国消防协会</span>
					<span>备案号：京ICP备17002894号</span>
				</li>
			</ul>
		</footer>
	</div>
</template>
<script>
	export default {
		name: "foot",
		data() {
			return {
				yqljtableData: [], //友情链接数据
				fwrs: 0,
				zxrs: 0,
			}
		},
		created() {},
		mounted() {

		},
		methods: {

		},

	};
</script>
<style scoped lang="scss">
	#foot {
		background-color: #EFF6FD;

		.index_footer {
			width: 100%;
			height: 180px;
			background-color: #1243CB;
		}

		.index_footer_link {
			width: 1200px;
			height: 60px;
			margin: 0 auto;
			border-bottom: 1px solid #4c71d9;
			text-align: center;
		}

		.index_footer_link a {
			position: relative;
			display: inline-block;
			height: 60px;
			line-height: 60px;
			color: white;
			padding: 0 12px;
			font-size: 16px;
			font-weight: bold;
		}

		.index_footer_link a::after {
			content: "";
			position: absolute;
			width: 1px;
			height: 15px;
			background: #4c71d9;
			right: 0;
			top: 22px;
		}

		.index_footer_link a:last-child::after {
			width: 0;
		}

		.index_footer_info {
			text-align: center;
		}

		.index_footer_info li {
			height: 40px;
			line-height: 40px;
		}

		.index_footer_info li span {
			font-size: 15px;
			color: white;
			margin-right: 20px;
		}

		.index_footer_info li em {
			font-size: 15px;
			color: white;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/portal/layout/Footer.vue